import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useAxios } from '../../utils/hook/useAxios';

function AvailabilitiesItem({ WeekDay, Data }) {
  let weekdays = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [selectedValue, setSelectedValue] = useState('');
  const [selectedValue2, setSelectedValue2] = useState('');
  const axios = useAxios();
  // Fonction pour gérer le changement de sélection
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleChange2 = (event) => {
    setSelectedValue2(event.target.value);
  };

  // Fonction pour générer les options pour les heures
  const generateHourOptions = () => {
    const options = [];

    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const hourString = hour.toString().padStart(2, '0'); // Ajouter un zéro en tête si nécessaire
        const minuteString = minute.toString().padStart(2, '0'); // Ajouter un zéro en tête si nécessaire
        const timeString = `${hourString}:${minuteString}`;
        options.push(
          <option key={timeString} value={timeString}>
            {timeString}
          </option>
        );
      }
    }

    return options;
  };

  const [IsAlwaysAvailable, setIsAlwaysAvailable] = useState(false);
  const [saving, setSaving] = useState(false);
  /* Tableau de booléens pour les 7 jours, le jour courant est pré-coché et désactivé */
  const [checked, setChecked] = useState(() =>
    Array.from({ length: 7 }, (_, i) => i === parseInt(WeekDay))
  );

  const toggleDay = (i) => {
    if (i === parseInt(WeekDay)) return; // jour courant non modifiable
    setChecked((prev) => prev.map((v, idx) => (idx === i ? !v : v)));
  };

  /* Jours sélectionnés (indices en string) */
  const selectedWeekdays = checked.map((v, i) => (v ? String(i) : null)).filter(Boolean);

  function getUserId() {
    const d = window.localStorage.getItem('VehicleStorage');
    return JSON.parse(d)?.userId;
  }

  async function handleChangeAvailabilities() {
    setSaving(true);
    try {
      await axios.put('/hoteavailabilities/updateHoteAvailabilitiesByUserId3/' + getUserId(), {
        ModeAvailability: Data.ModeAvailability,
        startTime: selectedValue,
        endTime: selectedValue2,
        Weekday: WeekDay,
      });
      window.location.reload();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  }

  async function handleApplyToOtherDays() {
    /* Applique les mêmes heures à tous les jours cochés (hors jour courant) */
    const otherDays = selectedWeekdays.filter((d) => d !== String(WeekDay));
    if (otherDays.length === 0) return;
    setSaving(true);
    try {
      await axios.put('/hoteavailabilities/updateHoteAvailabilitiesByUserId2/' + getUserId(), {
        ModeAvailability: Data.ModeAvailability,
        startTime: selectedValue,
        endTime: selectedValue2,
        Weekday: otherDays,
      });
      window.location.reload();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  }

  async function handleIsAlways() {
    setSaving(true);
    try {
      await axios.put('/hoteavailabilities/updateHoteAvailabilitiesByUserId2/' + getUserId(), {
        ModeAvailability: Data.ModeAvailability,
        startTime: '00:00',
        endTime: '23:59',
        Weekday: selectedWeekdays,
      });
      window.location.reload();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  }

  return (
    // <>
    //   <div
    //     className="card mb-2  "
    //     data-bs-toggle="offcanvas"
    //     data-bs-target={"#offcanvasRight" + WeekDay + Data.ModeAvailability}
    //     aria-controls={"offcanvasRight" + WeekDay + Data.ModeAvailability}
    //   >
    //     <div className="px-2 py-2  rounded  d-flex justify-content-between align-items-center">
    //       <div className="">
    //         <span className="badge bg-primary">Disponilité(s)</span>
    //         <p>
    //           <strong>{weekdays[WeekDay]}</strong>
    //         </p>
    //         <p className="text-muted">
    //           {Data.startTime} - {Data.endTime}
    //         </p>
    //       </div>

    //       <i class="bi bi-chevron-double-right"></i>
    //     </div>
    //   </div>

    //   <div
    //     class="offcanvas offcanvas-end"
    //     tabindex="-1"
    //     id={"offcanvasRight" + WeekDay + Data.ModeAvailability}
    //     aria-labelledby="offcanvasRightLabel"
    //   >
    //     <div class="offcanvas-header">
    //       <h5 class="offcanvas-title" id="offcanvasRightLabel">
    //         {weekdays[WeekDay]}
    //       </h5>
    //       <button
    //         type="button"
    //         class="btn-close"
    //         data-bs-dismiss="offcanvas"
    //         aria-label="Close"
    //       ></button>
    //     </div>
    //     <div class="offcanvas-body">
    //       <div className="card mb-3">
    //         {" "}
    //         <div className="form-check form-switch d-flex justify-content-between p-2">
    //           <label
    //             className="form-check-label py-1"
    //             htmlFor="flexSwitchCheckDefault5"
    //           >
    //             <strong>Toujours disponible</strong>
    //           </label>
    //           <input
    //             className="form-check-input"
    //             type="checkbox"
    //             role="switch"
    //             id="flexSwitchCheckDefault5"
    //             style={{ height: "30px", width: "70px" }}
    //             checked={IsAlwaysAvailable}
    //             onChange={(e) => setIsAlwaysAvailable(!IsAlwaysAvailable)}
    //           />
    //         </div>
    //       </div>

    //       <div className="card mb-3">
    //         {" "}
    //         <div className="form-check form-switch d-flex justify-content-between p-2">
    //           <label
    //             className="form-check-label py-1"
    //             htmlFor="flexSwitchCheckDefault6"
    //           >
    //             <strong>Heure</strong>
    //           </label>
    //         </div>
    //         <div className="p-2">
    //           {" "}
    //           <label htmlFor="heureDebut">Heure du début</label>
    //           <select
    //             class="form-select form-select-sm mb-3 p-2"
    //             aria-label="Small select example"
    //             value={selectedValue}
    //             onChange={handleChange}
    //             disabled={IsAlwaysAvailable}
    //           >
    //             {generateHourOptions()}
    //           </select>
    //           <label htmlFor="heureDebut">Heure du fin</label>
    //           <select
    //             class="form-select form-select-sm mb-3 p-2"
    //             aria-label="Small select example"
    //             value={selectedValue2}
    //             onChange={handleChange2}
    //             disabled={IsAlwaysAvailable}
    //           >
    //             {generateHourOptions()}
    //           </select>
    //           <button
    //             className="btn btn-primary w-100 text-white d-flex align-items-center justify-content-center gap-2"
    //             disabled={IsAlwaysAvailable || saving}
    //             onClick={handleChangeAvailabilities}
    //           >
    //             {saving
    //               ? <span className="spinner-border spinner-border-sm" />
    //               : <i className="bi bi-check2-circle"></i>
    //             }
    //             Modifier ce jour
    //           </button>
    //           <hr />
    //           <p className="fw-semibold small mb-2">Appliquer ces heures à d'autres jours</p>
    //           <div className="d-flex flex-wrap gap-2 mb-3">
    //             {["Lun","Mar","Mer","Jeu","Ven","Sam","Dim"].map((label, i) => (
    //               <label key={i}
    //                 className={`btn btn-sm ${checked[i] ? "btn-primary" : "btn-outline-secondary"} ${i === parseInt(WeekDay) ? "opacity-75" : ""}`}
    //                 style={{ cursor: i === parseInt(WeekDay) ? "default" : "pointer", minWidth: 44 }}
    //               >
    //                 <input
    //                   type="checkbox"
    //                   className="d-none"
    //                   checked={checked[i]}
    //                   disabled={i === parseInt(WeekDay)}
    //                   onChange={() => toggleDay(i)}
    //                 />
    //                 {label}
    //                 {i === parseInt(WeekDay) && <i className="bi bi-dot ms-1"></i>}
    //               </label>
    //             ))}
    //           </div>
    //           <button
    //             className="btn btn-outline-primary w-100 mb-2 d-flex align-items-center justify-content-center gap-2"
    //             disabled={IsAlwaysAvailable || saving || selectedWeekdays.filter(d => d !== String(WeekDay)).length === 0}
    //             onClick={handleApplyToOtherDays}
    //           >
    //             {saving
    //               ? <span className="spinner-border spinner-border-sm" />
    //               : <i className="bi bi-arrow-repeat"></i>
    //             }
    //             Appliquer aux jours sélectionnés
    //           </button>
    //           <button
    //             className="btn btn-outline-tertiary w-100"
    //             disabled={!IsAlwaysAvailable}
    //             onClick={handleIsAlways}
    //           >
    //             Rendre toujours disponible
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </>

    <>
      <div
        className="card mb-2"
        style={{ cursor: 'pointer' }}
        onClick={handleShow}
        /* data-bs attributes retirés car on utilise le state 'show' */
      >
        <div className="px-2 py-2 rounded d-flex justify-content-between align-items-center">
          <div className="">
            <span className="badge bg-primary">Disponibilité(s)</span>
            <p>
              <strong>{weekdays[WeekDay]}</strong>
            </p>
            <p className="text-muted">
              {Data.startTime} - {Data.endTime}
            </p>
          </div>

          <i className="bi bi-chevron-double-right"></i>
        </div>
      </div>

      {/* Uniquement Offcanvas de react-bootstrap */}
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">{weekdays[WeekDay]}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={handleClose}
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          <div className="card mb-3">
            <div className="form-check form-switch d-flex justify-content-between p-2">
              <label className="form-check-label py-1" htmlFor="flexSwitchCheckDefault5">
                <strong>Toujours disponible</strong>
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault5"
                style={{ height: '30px', width: '70px' }}
                checked={IsAlwaysAvailable}
                onChange={(e) => setIsAlwaysAvailable(!IsAlwaysAvailable)}
              />
            </div>
          </div>

          <div className="card mb-3">
            <div className="form-check form-switch d-flex justify-content-between p-2">
              <label className="form-check-label py-1">
                <strong>Heure</strong>
              </label>
            </div>
            <div className="p-2">
              <label htmlFor="heureDebut">Heure du début</label>
              <select
                className="form-select form-select-sm mb-3 p-2"
                value={selectedValue}
                onChange={handleChange}
                disabled={IsAlwaysAvailable}
              >
                {generateHourOptions()}
              </select>

              <label htmlFor="heureFin">Heure du fin</label>
              <select
                className="form-select form-select-sm mb-3 p-2"
                value={selectedValue2}
                onChange={handleChange2}
                disabled={IsAlwaysAvailable}
              >
                {generateHourOptions()}
              </select>

              <button
                className="btn btn-primary w-100 text-white d-flex align-items-center justify-content-center gap-2"
                disabled={IsAlwaysAvailable || saving}
                onClick={handleChangeAvailabilities}
              >
                {saving ? (
                  <span className="spinner-border spinner-border-sm" />
                ) : (
                  <i className="bi bi-check2-circle"></i>
                )}
                Modifier ce jour
              </button>

              <hr />

              <p className="fw-semibold small mb-2">Appliquer ces heures à d'autres jours</p>
              <div className="d-flex flex-wrap gap-2 mb-3">
                {['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'].map((label, i) => (
                  <label
                    key={i}
                    className={`btn btn-sm ${checked[i] ? 'btn-primary' : 'btn-outline-secondary'} ${i === parseInt(WeekDay) ? 'opacity-75' : ''}`}
                    style={{
                      cursor: i === parseInt(WeekDay) ? 'default' : 'pointer',
                      minWidth: 44,
                    }}
                  >
                    <input
                      type="checkbox"
                      className="d-none"
                      checked={checked[i]}
                      disabled={i === parseInt(WeekDay)}
                      onChange={() => toggleDay(i)}
                    />
                    {label}
                    {i === parseInt(WeekDay) && <i className="bi bi-dot ms-1"></i>}
                  </label>
                ))}
              </div>

              <button
                className="btn btn-outline-primary w-100 mb-2 d-flex align-items-center justify-content-center gap-2"
                disabled={
                  IsAlwaysAvailable ||
                  saving ||
                  selectedWeekdays.filter((d) => d !== String(WeekDay)).length === 0
                }
                onClick={handleApplyToOtherDays}
              >
                {saving ? (
                  <span className="spinner-border spinner-border-sm" />
                ) : (
                  <i className="bi bi-arrow-repeat"></i>
                )}
                Appliquer aux jours sélectionnés
              </button>

              <button
                className="btn btn-outline-tertiary w-100"
                disabled={!IsAlwaysAvailable}
                onClick={handleIsAlways}
              >
                Rendre toujours disponible
              </button>
            </div>
          </div>
        </div>
      </Offcanvas>
    </>
  );
}

export default AvailabilitiesItem;
